import styled from "styled-components";

/** The global reset removes the list style; the confirm dialogs list items as plain bullets. */
export const BulletList = styled.ul`
  list-style: disc;
  margin: 0 0 1rem;
  padding-left: 1.5rem;

  li {
    margin-bottom: 0.25rem;
  }
`;
